function nameStatus(status){
    switch(status){
        case '1': return '販売予定';
        case '2': return '販売中';
        case '3': return '販売終了';
    }
}

function statusColor(status){
    switch(status){
        case '1': return 'secondary';
        case '2': return 'primary';
        case '3': return 'secondary';
    }
}

export default {
    nameStatus,
    statusColor,
};